export default __webpack_public_path__ + "static/media/spid-idp-spiditalia.069a2f30.svg";